import withModalBasicContainer from "../hoc/withModalBasicContainer";
import ModalBasic from "../view/components/Modals/ModalBasic";

export default withModalBasicContainer(ModalBasic)